/** Organization datagrid key base — full key is `${EMPLOYEE_EXITS_DATAGRID_KEY}_${organizationId}` */
export const EMPLOYEE_EXITS_DATAGRID_KEY = "employee_exits_grid";

export const EMPLOYEE_EXIT_DEFAULT_COLUMNS = [
  {
    field: "employee_code",
    label: "Employee Code",
    visible: true,
    width: 120,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "employee_name",
    label: "Employee Name",
    visible: true,
    width: 200,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "exit_reason",
    label: "Exit Reason",
    visible: true,
    width: 180,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "resignation_date",
    label: "Resignation Date",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "notice_period_start",
    label: "Notice Period Start",
    visible: true,
    width: 170,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "notice_period_end",
    label: "Notice Period End",
    visible: true,
    width: 170,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "last_working_date",
    label: "Last Working Date",
    visible: true,
    width: 160,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "relieving_date",
    label: "Relieving Date",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "exit_interview_done",
    label: "Exit Interview Done",
    visible: true,
    width: 140,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const EMPLOYEE_EXIT_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: [
    "employee_code",
    "employee_name",
    "exit_reason",
    "resignation_date",
    "relieving_date",
    "exit_interview_done",
  ],
  columnLabels: Object.fromEntries(
    EMPLOYEE_EXIT_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    EMPLOYEE_EXIT_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const EMPLOYEE_EXIT_PERSONALIZE_COLUMN_KEYS =
  EMPLOYEE_EXIT_DEFAULT_COLUMNS.map((col) => col.field).concat(["comments"]);

/** Normalize saved/personalized column keys to match list API row keys. */
export function normalizeEmployeeExitColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  const lower = raw.toLowerCase();
  if (lower === "name" || lower === "full_name") return "employee_name";
  if (lower === "employment_exit_reason_name") return "exit_reason";
  return raw;
}

export function mapSavedEmployeeExitColumns(savedColumns = []) {
  const labelByField = EMPLOYEE_EXIT_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeEmployeeExitColumnField(col.field || col.key);
      if (!field || field === "employee_exit_id") return null;

      const defaultCol = EMPLOYEE_EXIT_DEFAULT_COLUMNS.find(
        (c) => c.field === field
      );

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}
